import { EXTERNAL_LINKS, ROUTES } from '@/utils/constants';
import type { LucideIcon } from 'lucide-react';
import {
  LayoutDashboard,
  Database,
  Box,
  Boxes,
  Code,
  ListChecks,
  TableProperties,
  Building2,
  Building,
  School,
  GraduationCap,
  Users,
  User,
  ShieldCheck,
  UserCog,
  FileText,
  Image,
  Megaphone,
  Info,
  CreditCard,
  Receipt,
  Coins,
  BarChart3,
  BarChart4,
  TrendingUp,
  FileBadge,
  Cloud,
  Wrench,
  UserCheck,
  Ticket,
  SlidersHorizontal,
  Tags,
  Zap,
  SmartphoneNfc,
  Clock,
  Layout,
  BrainCircuit,
  ClipboardList,
  Trophy,
  Dumbbell,
  Ruler,
  Layers,
  UsersRound,
  Files,
  Store,
  MessageSquarePlus,
  Smartphone,
  BadgeCheck,
  Award,
  FileSpreadsheet,
  Calculator,
  CalendarDays,
  ReceiptText,
  BookOpen,
  Wallet,
  Sparkles,
  Network,
  Scale,
  ArrowLeftRight,
  Briefcase,
  LayoutGrid,
  Globe,
  Landmark,
  Stethoscope,
  Palette,
  CalendarClock,
  HelpCircle,
  CheckCircle2,
  FolderArchive,
} from 'lucide-react';

export interface NavItem {
  label: string;
  path?: string;
  externalUrl?: string;
  icon: LucideIcon;
  children?: NavItem[];
  groupKey?: string;
  group?: string;
  rootGroup?: string;
  parentGroup?: string;
  ancestors?: string[];
  breadcrumb?: string;
  keywords?: string[];
  searchString?: string;
  isPrivate?: boolean;
}

export const NAV_ITEMS: NavItem[] = [
  {
    label: 'Dashboard',
    path: ROUTES.DASHBOARD,
    // isPrivate: true,
    icon: LayoutDashboard,
  },
  {
    label: 'Institute App',
    groupKey: 'group-institute-app',
    icon: Building2,
    children: [
       { label: 'Institute List', path: ROUTES.INSTITUTE_LIST, icon: Building },
    ],
  },
  {
    label: 'School App',
    groupKey: 'group-school-app',
    icon: GraduationCap,
    children: [
                { label: 'School List', path: ROUTES.SCHOOL_LIST, icon: GraduationCap },
 { label: 'Sheet Fields', path: ROUTES.SHEET_FIELD, icon: TableProperties },
       
          { label: 'Dynamic Variable', path: ROUTES.DYNAMIC_VARIABLE, icon: SlidersHorizontal },
          { label: 'Dynamic Variable Label', path: ROUTES.DYNAMIC_VARIABLE_LABEL, icon: Tags },
            {
    label: 'FRC Docs',
    path: ROUTES.FRC_DOCS,
    icon: FileText,
  },
    ],
  },
  {
    label: 'Global App',
    groupKey: 'group-global-app',
    icon: Globe,
    children: [],
  },
  {
    label: 'Student App',
    groupKey: 'group-student-app',
    icon: User,
    children: [],
  },
  {
    label: 'Vendor App',
    groupKey: 'group-vendor-app',
    icon: Store,
    children: [
         {
        label: 'Add Category',
        path: ROUTES.MARKETPLACE_ADD_CATEGORY,
        icon: Tags,
        // isPrivate: true,
      },
      {
        label: 'Attribute',
        path: ROUTES.MARKETPLACE_ATTRIBUTE,
        icon: SlidersHorizontal,
        // isPrivate: true,
      },
      {
        label: 'Company Approval Req',
        path: ROUTES.MARKETPLACE_COMPANY_APPROVAL,
        icon: ShieldCheck,
        // isPrivate: true,
      },
      {
        label: 'Announcements',
        path: ROUTES.VENDOR_ANNOUNCEMENTS,
        icon: Megaphone,
      },
    ],
  },
  {
    label: 'Arena App',
    groupKey: 'group-arena-app',
    icon: Trophy,
    children: [
         {
        label: 'Sports',
        path: ROUTES.ARENA_SPORTS,
        icon: Trophy,
      },
      {
        label: 'Sport Categories',
        path: ROUTES.ARENA_SPORT_CATEGORIES,
        icon: Tags,
      },
      {
        label: 'Sport Sub Categories',
        path: ROUTES.ARENA_SPORT_SUB_CATEGORIES,
        icon: Boxes,
      },
      {
        label: 'Sport Roles',
        path: ROUTES.ARENA_SPORT_ROLES,
        icon: UserCog,
      },
      {
        label: 'Equipments',
        path: ROUTES.ARENA_EQUIPMENTS,
        icon: Dumbbell,
      },
      {
        label: 'Facility Masters',
        path: ROUTES.ARENA_FACILITY_MASTERS,
        icon: Building2,
      },
      {
        label: 'Facility Amenities',
        path: ROUTES.ARENA_FACILITY_AMENITIES,
        icon: Building2,
      },
      {
        label: 'Units',
        path: ROUTES.ARENA_UNITS,
        icon: Ruler,
      },
      {
        label: 'Skills',
        path: ROUTES.ARENA_SKILLS,
        icon: Zap,
      },
      {
        label: 'Age Groups',
        path: ROUTES.ARENA_AGE_GROUPS,
        icon: Users,
      },
      {
        label: 'Sport Group Data',
        path: ROUTES.ARENA_SPORT_GROUP_DATA,
        icon: Layers,
      },
      {
        label: 'Assessment Tests',
        path: ROUTES.ARENA_ASSESSMENT_TESTS,
        icon: ClipboardList,
      },
      {
        label: 'Sport Infos',
        path: ROUTES.ARENA_SPORT_INFOS,
        icon: Info,
      },
      {
        label: 'Announcements',
        path: ROUTES.ARENA_ANNOUNCEMENTS,
        icon: Megaphone,
      },
    ],
  },
  {
    label: 'College App',
    groupKey: 'group-college-app',
    icon: Landmark,
    children: [
      { label: 'College List', path: ROUTES.COLLEGE_LIST, icon: Landmark },
    ],
  },
  {
    label: 'Alumni App',
    groupKey: 'group-alumni-app',
    icon: Award,
    children: [],
  },
  {
    label: 'Kipigovt App',
    groupKey: 'group-kipigovt-app',
    icon: ShieldCheck,
    children: [
       {
            label: 'Education Officers',
            path: ROUTES.EDUCATION_OFFICER,
            icon: UserCheck,
            // isPrivate: true,
          },
          {
            label: 'DEO/DPEO',
            path: ROUTES.DEO_DPEO,
            icon: ShieldCheck,
          },
          {
            label: 'Announcements',
            path: ROUTES.KIPIGOVT_ANNOUNCEMENTS,
            icon: Megaphone,
          },
    ],
  },
  {
    label: 'Doctor App',
    groupKey: 'group-doctor-app',
    icon: Stethoscope,
    children: [
      { label: 'Hospital List', path: ROUTES.HOSPITAL_LIST, icon: Stethoscope },
    ],
  },
  {
    label: 'QA Config',
    groupKey: 'group-qa-config',
    icon: HelpCircle,
    children: [
      { label: 'Question Source', path: ROUTES.QA_QUESTION_SOURCE, icon: BookOpen },
      { label: 'Answer Source', path: ROUTES.QA_ANSWER_SOURCE, icon: CheckCircle2 },
      { label: 'Question Type', path: ROUTES.QA_QUESTION_TYPE, icon: ListChecks },
      {
        label: 'Question Difficulty Level',
        path: ROUTES.QA_QUESTION_DIFFICULTY_LEVEL,
        icon: BarChart3,
      },
      {
        label: 'Question Cognitive Level',
        path: ROUTES.QA_QUESTION_COGNITIVE_LEVEL,
        icon: BrainCircuit,
      },
    ],
  },
  {
    label: 'Guest App',
    groupKey: 'group-guest-app',
    icon: UserCheck,
    children: [],
  },
  {
    label: 'Expo App',
    groupKey: 'group-expo',
    icon: Store,
    children: [
      {
        label: 'Expo List',
        path: ROUTES.EXPO,
        icon: Store,
      },
      {
        label: 'Expo Grid',
        path: ROUTES.EXPO_GRID,
        icon: LayoutGrid,
      },
      {
        label: 'Expo Stall',
        path: ROUTES.EXPO_STALL,
        icon: Boxes,
      },
      {
        label: 'Stage Slot',
        path: ROUTES.EXPO_STAGE_SLOT,
        icon: CalendarClock,
      },
    ],
  },
   {
    label: 'User Types & Users',
    groupKey: 'group-user-types-users',
    // isPrivate: true,
    icon: Users,
    children: [
      { label: 'Master Admins', path: ROUTES.MASTER_ADMINS_LIST, icon: User },
      { label: 'Admins', path: ROUTES.ADMINS_LIST, icon: User },
      {
        label: 'Institute Master Admins',
        path: ROUTES.INSTITUTE_MASTER_ADMINS_LIST,
        icon: User,
      },
      { label: 'Institute Admins', path: ROUTES.INSTITUTE_ADMINS_LIST, icon: User },
      { label: 'Teachers', path: ROUTES.TEACHERS_LIST, icon: User },
      { label: 'Students', path: ROUTES.STUDENTS_LIST, icon: User },
      { label: 'Parents', path: ROUTES.PARENTS_LIST, icon: User },
      { label: 'Drivers', path: ROUTES.DRIVERS_LIST, icon: User },
      { label: 'Vendors', path: ROUTES.VENDORS_LIST, icon: User },
      {
        label: 'Sport Institute Owners',
        path: ROUTES.SPORT_INSTITUTE_OWNERS_LIST,
        icon: User,
      },
      { label: 'Sport Trainers', path: ROUTES.SPORT_TRAINERS_LIST, icon: User },
      { label: 'Sport Athletes', path: ROUTES.SPORT_ATHLETES_LIST, icon: User },
      { label: 'DEO / DPEO', path: ROUTES.DEO_DPEO_LIST, icon: User },
      { label: 'DEO / DPEO Staff', path: ROUTES.DEO_DPEO_STAFF_LIST, icon: User },
      {
        label: 'Agency Master Admins',
        path: ROUTES.AGENCY_MASTER_ADMINS_LIST,
        icon: User,
      },
      { label: 'Job Seekers', path: ROUTES.JOB_SEEKERS_LIST, icon: User },
    ],
  },
    {
    label: 'Roles & Permissions',
    groupKey: 'group-roles-and-permissions',
    // isPrivate: true,
    icon: ShieldCheck,
    children: [
      {
        label: 'Institute App',
        groupKey: 'group-roles-institute-app',
        // isPrivate: true,
        icon: Building2,
        children: [
          {
            label: 'Module Permissions',
            path: '/app-permissions/INSTITUTE_APP',
            icon: Code,
            // isPrivate: true,
          },
          {
            label: 'Roles & Permission',
            path: '/app-roles/INSTITUTE_APP',
            icon: ShieldCheck,
            // isPrivate: true,
          },
        ],
      },
      {
        label: 'School App',
        groupKey: 'group-roles-school-app',
        // isPrivate: true,
        icon: Building,
        children: [
          {
            label: 'Module Permissions',
            path: '/app-permissions/SCHOOL_APP',
            icon: Code,
            // isPrivate: true,
          },
          {
            label: 'Roles & Permission',
            path: '/app-roles/SCHOOL_APP',
            icon: ShieldCheck,
            // isPrivate: true,
          },
        ],
      },
      {
        label: 'Global App',
        groupKey: 'group-roles-global-app',
        // isPrivate: true,
        icon: Cloud,
        children: [
          {
            label: 'Module Permissions',
            path: '/app-permissions/GLOBAL_APP',
            icon: Code,
            // isPrivate: true,
          },
          {
            label: 'Roles & Permission',
            path: '/app-roles/GLOBAL_APP',
            icon: ShieldCheck,
            // isPrivate: true,
          },
        ],
      },
      {
        label: 'Student App',
        groupKey: 'group-roles-student-app',
        // isPrivate: true,
        icon: GraduationCap,
        children: [
          {
            label: 'Module Permissions',
            path: '/app-permissions/STUDENT_APP',
            icon: Code,
            // isPrivate: true,
          },
          {
            label: 'Roles & Permission',
            path: '/app-roles/STUDENT_APP',
            icon: ShieldCheck,
            // isPrivate: true,
          },
        ],
      },
      {
        label: 'Vendor App',
        groupKey: 'group-roles-vendor-app',
        // isPrivate: true,
        icon: Store,
        children: [
          {
            label: 'Module Permissions',
            path: '/app-permissions/VENDOR_APP',
            icon: Code,
            // isPrivate: true,
          },
          {
            label: 'Roles & Permission',
            path: '/app-roles/VENDOR_APP',
            icon: ShieldCheck,
            // isPrivate: true,
          },
        ],
      },
      {
        label: 'Arena App',
        groupKey: 'group-roles-arena-app',
        // isPrivate: true,
        icon: Dumbbell,
        children: [
          {
            label: 'Module Permissions',
            path: '/app-permissions/ARENA_APP',
            icon: Code,
            // isPrivate: true,
          },
          {
            label: 'Roles & Permission',
            path: '/app-roles/ARENA_APP',
            icon: ShieldCheck,
            // isPrivate: true,
          },
        ],
      },
      {
        label: 'College App',
        groupKey: 'group-roles-college-app',
        // isPrivate: true,
        icon: GraduationCap,
        children: [
          {
            label: 'Module Permissions',
            path: '/app-permissions/COLLEGE_APP',
            icon: Code,
            // isPrivate: true,
          },
          {
            label: 'Roles & Permission',
            path: '/app-roles/COLLEGE_APP',
            icon: ShieldCheck,
            // isPrivate: true,
          },
        ],
      },
      {
        label: 'Alumni App',
        groupKey: 'group-roles-alumni-app',
        // isPrivate: true,
        icon: Users,
        children: [
          {
            label: 'Module Permissions',
            path: '/app-permissions/ALUMNI_APP',
            icon: Code,
            // isPrivate: true,
          },
          {
            label: 'Roles & Permission',
            path: '/app-roles/ALUMNI_APP',
            icon: ShieldCheck,
            // isPrivate: true,
          },
        ],
      },
      {
        label: 'KipiGovt App',
        groupKey: 'group-roles-kipigovt-app',
        // isPrivate: true,
        icon: Building2,
        children: [
          {
            label: 'Module Permissions',
            path: '/app-permissions/KIPIGOVT_APP',
            icon: Code,
            // isPrivate: true,
          },
          {
            label: 'Roles & Permission',
            path: '/app-roles/KIPIGOVT_APP',
            icon: ShieldCheck,
            // isPrivate: true,
          },
        ],
      },
      {
        label: 'Doctor App',
        groupKey: 'group-roles-doctor-app',
        // isPrivate: true,
        icon: UserCheck,
        children: [
          {
            label: 'Module Permissions',
            path: '/app-permissions/DOCTOR_APP',
            icon: Code,
            // isPrivate: true,
          },
          {
            label: 'Roles & Permission',
            path: '/app-roles/DOCTOR_APP',
            icon: ShieldCheck,
            // isPrivate: true,
          },
        ],
      },
      {
        label: 'Guest App',
        groupKey: 'group-roles-guest-app',
        // isPrivate: true,
        icon: User,
        children: [
          {
            label: 'Module Permissions',
            path: '/app-permissions/ADMISSIONS_AGENCY_APP',
            icon: Code,
            // isPrivate: true,
          },
          {
            label: 'Roles & Permission',
            path: '/app-roles/ADMISSIONS_AGENCY_APP',
            icon: ShieldCheck,
            // isPrivate: true,
          },
        ],
      },
      {
        label: 'Expo App',
        groupKey: 'group-roles-expo-app',
        // isPrivate: true,
        icon: Layers,
        children: [
          {
            label: 'Module Permissions',
            path: '/app-permissions/EXPO_APP',
            icon: Code,
            // isPrivate: true,
          },
          {
            label: 'Roles & Permission',
            path: '/app-roles/EXPO_APP',
            icon: ShieldCheck,
            // isPrivate: true,
          },
        ],
      },
    ],
  },
      {
    label: 'Maintenance',
    groupKey: 'group-maintenance',
    // isPrivate: true,
    icon: Wrench,
    children: [
      {
        label: 'Institute App',
        path: '/maintenance/app/INSTITUTE_APP',
        icon: Building2,
      },
      {
        label: 'School App',
        path: '/maintenance/app/SCHOOL_APP',
        icon: GraduationCap,
      },
      {
        label: 'Global App',
        path: '/maintenance/app/GLOBAL_APP',
        icon: Globe,
      },
      {
        label: 'Student App',
        path: '/maintenance/app/STUDENT_APP',
        icon: User,
      },
      {
        label: 'Vendor App',
        path: '/maintenance/app/VENDOR_APP',
        icon: Store,
      },
      {
        label: 'Arena App',
        path: '/maintenance/app/ARENA_APP',
        icon: Trophy,
      },
      {
        label: 'College App',
        path: '/maintenance/app/COLLEGE_APP',
        icon: Landmark,
      },
      {
        label: 'Alumni App',
        path: '/maintenance/app/ALUMNI_APP',
        icon: Award,
      },
      {
        label: 'Kipigovt App',
        path: '/maintenance/app/KIPIGOVT_APP',
        icon: ShieldCheck,
      },
      {
        label: 'Doctor App',
        path: '/maintenance/app/DOCTOR_APP',
        icon: Stethoscope,
      },
      {
        label: 'Guest App',
        path: '/maintenance/app/ADMISSIONS_AGENCY_APP',
        icon: UserCheck,
      },
      {
        label: 'Expo App',
        path: '/maintenance/app/EXPO_APP',
        icon: Boxes,
      },
    ],
  },
    {
    label: 'Subscription Plans',
    groupKey: 'group-subscription-plans',
    // isPrivate: true,
    icon: CreditCard,
    children: [
      { label: 'Subscription Plans', path: ROUTES.VIEW_SUBSCRIPTION_PLAN, icon: Receipt },
      { label: 'Module Price', path: ROUTES.MODULE_PRICE, icon: Tags },
      {
        label: 'Subscription Plan Usage',
        path: ROUTES.SUBSCRIPTION_DASHBOARD,
        icon: BarChart4,
      },
      {
        label: 'Subscription Analysis',
        path: ROUTES.SUBSCRIPTION_ANALYSIS,
        icon: TrendingUp,
      },
    ],
  },
  {
    label: 'Storage & Credits',
    groupKey: 'group-storage-credits',
    // isPrivate: true,
    icon: Database,
    children: [
      { label: 'Coin Offers', path: ROUTES.COIN_OFFER, icon: Coins },
      { label: 'Coin History', path: ROUTES.COIN_HISTORY, icon: Coins },
      { label: 'Cloud Storage', path: ROUTES.CLOUD_STORAGE, icon: Cloud },
      { label: 'Storage History', path: ROUTES.STORAGE_HISTORY, icon: Cloud },
      {
        label: 'Subscription Configuration',
        path: ROUTES.SUBSCRIPTION_CONFIGURATION,
        icon: SlidersHorizontal,
      },
    ],
  },
    {
    label: 'Marketing',
    groupKey: 'group-marketing',
    // isPrivate: true,
    icon: Megaphone,
    children: [
      { label: 'Banners', path: ROUTES.BANNER, icon: Image },
      { label: 'Announcements', path: ROUTES.ANNOUNCEMENT, icon: Megaphone },
      { label: 'Advertisements', path: ROUTES.ADVERTISEMENT, icon: Layout },
    ],
  },
    {
    label: 'Designation',
    groupKey: 'group-designation-app',
    icon: UserCheck,
    children: [
         { label: 'Designation', path: ROUTES.DESIGNATION, icon: UserCheck },
          { label: 'New Designation', path: ROUTES.NEW_DESIGNATION, icon: UserCheck },
    ],
  },

  {
    label: 'Accounting Configuration',
    groupKey: 'group-accounting-configuration',
    // isPrivate: true,
    icon: Calculator,
    children: [
      {
        label: 'Financial Years',
        path: ROUTES.ACCOUNTING_FINANCIAL_YEARS,
        icon: CalendarDays,
        // isPrivate: true,
      },
      {
        label: 'Voucher Types',
        path: ROUTES.ACCOUNTING_VOUCHER_TYPES,
        icon: ReceiptText,
        // isPrivate: true,
      },
      {
        label: 'Account Groups',
        path: ROUTES.ACCOUNTING_ACCOUNT_GROUPS,
        icon: BookOpen,
        // isPrivate: true,
      },
      {
        label: 'Account Ledgers',
        path: ROUTES.ACCOUNTING_ACCOUNT_LEDGERS,
        icon: Wallet,
        // isPrivate: true,
      },
      {
        label: 'Journal Mappings',
        path: ROUTES.ACCOUNTING_JOURNAL_MAPPINGS,
        icon: ArrowLeftRight,
        // isPrivate: true,
      },
      {
        label: 'Cost Centers',
        path: ROUTES.ACCOUNTING_COST_CENTERS,
        icon: Building2,
        // isPrivate: true,
      },
    ],

  },
    {
    label: 'TEPDS',
    groupKey: 'group-tepds',
    // isPrivate: true,
    icon: Award,
    children: [
      {
        label: 'Category',
        path: ROUTES.TEPDS_CATEGORY,
        icon: Tags,
        // isPrivate: true,
      },
      {
        label: 'Rating Scales',
        path: ROUTES.TEPDS_RATING_SCALES,
        icon: SlidersHorizontal,
        // isPrivate: true,
      },
      {
        label: 'Templates',
        path: ROUTES.TEPDS_TEMPLATES,
        icon: FileSpreadsheet,
        // isPrivate: true,
      },
      {
        label: 'Template Map',
        path: ROUTES.TEPDS_TEMPLATE_MAPS,
        icon: Network,
      },
      {
        label: 'Evaluation Weight',
        path: ROUTES.TEPDS_WEIGHT_CONFIGS,
        icon: Scale,
      },
    ],
  },

     {
        label: 'Approvals',
        groupKey: 'sub-approvals',
        icon: BadgeCheck,
        children: [
          { label: 'School', path: ROUTES.APPROVAL_SCHOOLS, icon: GraduationCap },
          { label: 'Institute', path: ROUTES.APPROVAL_INSTITUTES, icon: Building },
          { label: 'College', path: ROUTES.APPROVAL_COLLEGES, icon: School },
          { label: 'Teacher', path: ROUTES.APPROVAL_TEACHERS, icon: UserCheck },
          { label: 'Student', path: ROUTES.APPROVAL_STUDENTS, icon: User },
          { label: 'Sports Academy', path: ROUTES.APPROVAL_SPORTS_ACADEMIES, icon: Trophy },
          { label: 'Trainer', path: ROUTES.APPROVAL_TRAINERS, icon: Dumbbell },
          { label: 'Athleet', path: ROUTES.APPROVAL_ATHLETES, icon: Award },
          { label: 'Company Approval Req', path: ROUTES.MARKETPLACE_COMPANY_APPROVAL, icon: Building2 },
          { label: 'Agency', path: ROUTES.APPROVAL_AGENCIES, icon: Briefcase },
          { label: 'Hospital', path: ROUTES.APPROVAL_HOSPITALS, icon: Stethoscope },
          { label: 'Sports Amenities', path: ROUTES.APPROVAL_SPORTS_AMENITIES, icon: Sparkles },
        ],
      },
  { label: 'Master Setting', path: ROUTES.MASTER_SETTINGS, icon: SlidersHorizontal },

  {
    label: 'Super Admin',
    groupKey: 'group-super-admin',
    // isPrivate: true,
    icon: ShieldCheck,
    children: [{ label: 'Sub Admins', path: ROUTES.SUB_ADMINS, icon: UserCog }],
  },



 

  {
    label: 'App Analytics',
    groupKey: 'group-app-analytics',
    // isPrivate: true,
    icon: BarChart3,
    children: [
      { label: 'Dashboard', path: ROUTES.ANALYTICS_DASHBOARD, icon: LayoutDashboard },
      { label: 'Engagement', path: ROUTES.ANALYTICS_ENGAGEMENT, icon: Zap },
      { label: 'Version', path: ROUTES.ANALYTICS_VERSION, icon: SmartphoneNfc },
      { label: 'Pattern', path: ROUTES.ANALYTICS_PATTERN, icon: Clock },
    ],
  },
  {
    label: 'Complaint & Tickets',
    // isPrivate: true,
    icon: Ticket,
    path: ROUTES.TICKET,
  },


  {
    label: 'Demo App Management',
    path: ROUTES.APPLICATION_MANAGEMENT,
    // isPrivate: true,
    icon: Smartphone,
  },
  {
    label: 'AI Datasets',
    path: ROUTES.MODULE_DOC_AI,
    // isPrivate: true,
    icon: BrainCircuit,
  },
  {
    label: 'New Inquiry',
    path: ROUTES.KIPIVERSE_INQUIRYS,
    // isPrivate: true,
    icon: MessageSquarePlus,
  },
 
  {
    label: 'E-Learning Courses',
    path: ROUTES.E_LEARNING,
    // isPrivate: true,
    icon: GraduationCap,
  },

  {
    label: 'Type Management',
    path: ROUTES.TYPE_MANAGEMENT,
    // isPrivate: true,
    icon: ListChecks,
  },

  {
    label: 'Informatics',
    path: ROUTES.INFORMATION,
    // isPrivate: true,
    icon: Info,
  },
  {
    label: 'Sample Files',
    path: ROUTES.SAMPLE_FILES,
    // isPrivate: true,
    icon: Files,
  },
  {
    label: 'Public File Management',
    path: ROUTES.PUBLIC_FILES,
    icon: FolderArchive,
  },
  {
    label: 'Concern Letter Formats',
    path: ROUTES.TERMS_AND_CONDITION,
    // isPrivate: true,
    icon: FileText,
  },
  {
    label: 'Communities',
    path: ROUTES.COMMUNITY_GROUP,
    // isPrivate: true,
    icon: UsersRound,
  },

  {
    label: 'Reports & Certificates',
    groupKey: 'group-reports-certificates',
    // isPrivate: true,
    icon: FileBadge,
    children: [
      { label: 'Report Columns', path: ROUTES.REPORT_COLUMNS, icon: BarChart4 },
      { label: 'Certificates', path: ROUTES.CERTIFICATES_MANAGEMENT, icon: FileBadge },
      { label: 'Custom Certificates', path: ROUTES.CUSTOM_CERTIFICATES, icon: Award },
    ],
  },
  {
    label: 'Entities',
    groupKey: 'group-entities',
    // isPrivate: true,
    icon: Boxes,
    children: [
      { label: 'Entity', path: ROUTES.ENTITY, icon: Box },
      { label: 'Entity Type', path: ROUTES.ENTITYTYPE, icon: Boxes },
    ],
  },
  {
    label: 'Theme',
    path: ROUTES.THEME,
    icon: Palette,
  },
  {
    label: 'AI',
    externalUrl: EXTERNAL_LINKS.AI_ADMIN,
    icon: Sparkles,
  },
];

/**
 * Returns a flat list of all navigable pages for the search palette.
 * Groups themselves are NOT included — only leaf items with a path or externalUrl.
 * Traverses recursively to handle multi-level nested sidebars dynamically,
 * preserving all ancestor breadcrumbs and computing rich search tokens.
 */
export const getFlatNavItems = (): NavItem[] => {
  const result: NavItem[] = [];

  const recurse = (item: NavItem, ancestors: string[] = [], parentIsPrivate = false) => {
    const isPrivate = Boolean(item.isPrivate || parentIsPrivate);

    // Leaf item that can be navigated to
    if (item.path || item.externalUrl) {
      const rootGroup = ancestors[0] || item.label || 'Quick Access';
      const parentGroup = ancestors.length > 0 ? ancestors[ancestors.length - 1] : undefined;
      const breadcrumb = ancestors.length > 0 ? ancestors.join(' › ') : rootGroup;

      const pathText = item.path ? item.path.replace(/[^a-zA-Z0-9]/g, ' ') : '';
      const keywords = [
        item.label,
        ...ancestors,
        ...(parentGroup && parentGroup !== item.label ? [parentGroup] : []),
        ...(item.path ? [item.path, pathText] : []),
      ];

      result.push({
        ...item,
        group: rootGroup,
        rootGroup,
        parentGroup,
        ancestors,
        breadcrumb,
        keywords,
        searchString: `${ancestors.join(' ')} ${item.label} ${item.path || ''} ${pathText}`.trim(),
        isPrivate,
      });
    }

    if (item.children && item.children.length > 0) {
      item.children.forEach((child) => {
        recurse(child, [...ancestors, item.label], isPrivate);
      });
    }
  };

  NAV_ITEMS.forEach((item) => recurse(item, []));
  return result;
};
